import useSimBilling from 'api/sims/useSimBilling';
import { useMemo } from 'react';
import apiDateToDateTime from 'utils/dates/apiDateToDateTime';

interface UseSimBillingPeriodProps {
  hologramSimId?: HologramSimId;
}

const useSimBillingPeriod = ({ hologramSimId }: UseSimBillingPeriodProps) => {
  const { simBilling, isLoading, error } = useSimBilling(hologramSimId);

  const { billingPeriodStart, billingPeriodEnd } = simBilling;

  const simBillingPeriod = useMemo(() => {
    const billingPeriodStartInSec = apiDateToDateTime(billingPeriodStart)?.toUnixInteger();
    const billingPeriodEndInSec = apiDateToDateTime(billingPeriodEnd)?.toUnixInteger();
    const billingPeriodStartMs = billingPeriodStartInSec
      ? billingPeriodStartInSec * 1000
      : undefined;
    const billingPeriodEndMs = billingPeriodEndInSec ? billingPeriodEndInSec * 1000 : undefined;

    return { billingPeriodStartMs, billingPeriodEndMs };
  }, [billingPeriodEnd, billingPeriodStart]);

  return { simBillingPeriod, isLoading, error };
};

export default useSimBillingPeriod;
